module.exports = __webpack_public_path__ + "static/media/Shadbrook-Building-Restrictions.c1830efb.pdf";